module.exports = __webpack_public_path__ + "static/media/BroadImg.6fe21e0c.png";